import React from "react";
import { useQuery } from "@tanstack/react-query";
import FloatingSlideOutSidebar from "../../../ui-components/floating-slide-out-sidebar/floatingSlideOutSidebar";
import { QUERY_KEYS } from "../../../app/data/common/queryKeys";
import CommunicationsService from "../../../app/data/communications/communicationsService";
import { INBOX_STATIC_QUERY_OPTIONS } from "../../pickup/inbox/utils/pickupInboxQueryOptions";
import EmailMimeViewer from "./EmailMimeViewer";

const communicationsService = CommunicationsService.getInstance();

export const EMAIL_VIEWER_FLOATING_STORAGE_KEY = "pickup-inbox-email-viewer";

export interface EmailViewerMetadata {
  sender?: string;
  receiver?: string;
  subject?: string;
  receivedAt?: string;
}

export interface EmailViewerSidebarProps {
  messageId: number | null;
  metadata?: EmailViewerMetadata;
  webLink?: string;
  show: boolean;
  onClose: () => void;
}

const EmailViewerSidebar: React.FC<EmailViewerSidebarProps> = ({
  messageId,
  metadata,
  webLink,
  show,
  onClose,
}) => {
  const {
    data: mimeBase64,
    isLoading,
    isError,
  } = useQuery({
    queryKey: [QUERY_KEYS.PICKUP_INBOX_EMAIL_MIME, messageId],
    queryFn: () => communicationsService.getMimeBase64(messageId!),
    enabled: show && messageId != null,
    retry: false,
    ...INBOX_STATIC_QUERY_OPTIONS,
  });

  const header = metadata?.subject?.trim() || "Email";

  return (
    <FloatingSlideOutSidebar
      storageKey={EMAIL_VIEWER_FLOATING_STORAGE_KEY}
      header={header}
      onClose={onClose}
      show={show}
      spinner={isLoading}
      size="medium-860"
      className="xgs-email-viewer-sidebar"
    >
      <EmailMimeViewer
        rawMimeBase64={mimeBase64 ?? null}
        sender={metadata?.sender}
        receiver={metadata?.receiver}
        subject={metadata?.subject}
        receivedAt={metadata?.receivedAt}
        webLink={webLink}
        isLoading={isLoading}
        isError={isError || (!isLoading && !mimeBase64)}
        showHeader
        viewEmailAsLink={false}
      />
    </FloatingSlideOutSidebar>
  );
};

export default EmailViewerSidebar;
